import createReducer from 'reducers/createReducer';

import { RealTimeCommunicationHub } from 'actions/actionTypes';

const INITIAL_STATE = {
    hubs: {
        gameClientControl: null,
    },
    resetTimer: 0,
    error: {
        triggered: false,
        message: ''
    },
};

const reducer = createReducer(INITIAL_STATE, {
    [RealTimeCommunicationHub.CHANGE_REAL_TIME_COMMUNICATION_HUB]: (state, action) => {
        state.hubs[action.payload.type] = action.payload.hub;
    },

    [RealTimeCommunicationHub.RESET_TIMER]: (state, action) => {
        state.resetTimer = state.resetTimer + 1;
    },
});

export default reducer;